import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolderLink: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconFolderLink"><Path d="M2.5 10.5V3.5H10L12 6.5H21.5V19.5H14.5" stroke="currentColor" strokeLinecap="square"/><Path d="M5.55859 17H7.67398" stroke="currentColor" strokeLinecap="square"/><Path d="M5.36548 20.5H5C3.067 20.5 1.5 18.933 1.5 17C1.5 15.067 3.067 13.5 5 13.5H5.36548" stroke="currentColor" strokeLinecap="square"/><Path d="M7.86523 20.5H8.23053C10.1635 20.5 11.7305 18.933 11.7305 17C11.7305 15.067 10.1635 13.5 8.23053 13.5H7.86523" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconFolderLink;
